import Box from "@mui/material/Box";
import { useCallback, useEffect, useState } from "react";
import { useGetCreditNoteService } from "subModule/src/services/inventory/useInventory";
import { useSnackbar } from "notistack";
import AlertMessages from "common/Alert/AlertMessages";
import { useTranslation } from "react-i18next";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import Loader from "layout/Loader";
import BackendPaginationTable from "common/Table/TableWithPagination";
import ComponentHeaderTwo from "common/ComponentHeaderTwo/ComponentHeaderTwo";
import CreditIcon from "@mui/icons-material/CreditScore";
import { useNavigate } from "react-router-dom";
import StyledInput from "common/SearchField/Search";
interface CreditProps {
  supplierId?: number;
}
export default function CreditNoteListing(props: CreditProps) {
  const navigate = useNavigate();
  const [pageNo, setPageNo] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(props?.supplierId ? 5 : 20);
  const [searchTerm, setSearchTerm] = useState<any>("");
  const [search, setSearch] = useState("");
  const {
    data: tableData,
    isFetching,
    refetch,
  } = searchTerm
    ? useGetCreditNoteService({
        pageNumber: pageNo,
        size: pageSize,
        pCDNNumber: searchTerm,
        ...(props?.supplierId && { supplierId: props.supplierId }),
      })
    : useGetCreditNoteService({
        pageNumber: pageNo,
        size: pageSize,
        ...(props?.supplierId && { supplierId: props.supplierId }),
      });
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const fetchData = useCallback(() => {
    refetch().then((res: any) => {
      if (!res?.data?.pages[0]?.success)
        enqueueSnackbar(
          <AlertMessages
            text={res?.data?.pages[0]?.message || "Something went wrong"}
          />,
          { variant: "error" },
        );
    });
  }, []);
  useEffect(() => {
    fetchData();
  }, [pageNo, pageSize, searchTerm]);
  const handleChangePage = (pageNo: number) => {
    setPageNo(pageNo + 1);
  };
  const handleChangeRows = (pageSize: number) => {
    setPageSize(pageSize);
    setPageNo(1);
  };
  const navigationState = { state: { supplier: props?.supplierId || null } };
  const showRowView = (row: any) => {
    if (row.status === 2 || row.status === 3 || row.status === 4)
      navigate("/inventory/debit-note/" + row.id + "/print", navigationState);
    else navigate("/inventory/debit-note/" + row.id, navigationState);
  };
  const clearSearch = () => {
    setSearch("");
    setSearchTerm("");
    if (searchTerm) {
      handleSearch("");
    }
  };
  const handleSearch = (search: string) => {
    setSearchTerm(search);
    setPageNo(1);
    setPageSize(pageSize);
  };

  const handleSearchClick = () => {
    const trimmedSearch = search.trim();
    if (trimmedSearch !== "") {
      handleSearch(trimmedSearch);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value.trim());
    if (!event.target.value.trim()) handleSearch("");
  };

  return (
    <Box>
      {props?.supplierId ? null : (
        <ComponentHeaderTwo
          showBtn={true}
          showSaveBtn={false}
          onClick={() => navigate("/inventory/new-debit-note")}
          heading={t("Debit Notes")}
          icon={
            <CreditIcon
              sx={{
                fill: "#000",
                width: "30px",
                height: "30px",
                marginTop: "3px",
              }}
            />
          }
          btnText={"create"}
          btnType={"create"}
          showCreateBtn={checkPrivileges(
            "ROLE_PURCHASE_CREDITDEBITNOTE_CREATE",
          )}
        />
      )}
      <Box>
        {isFetching ? (
          <Loader />
        ) : (
          <div id="mainListingTable">
            <BackendPaginationTable
              columns={[
                {
                  id: "creditDebitNoteNumber",
                  label: "Debit Note Number",
                  numeric: false,
                  width: "20%",
                },
                {
                  id: "creditDebitDate",
                  label: "Date",
                  numeric: false,
                  width: "14%",
                },
                {
                  id: "vendorTitle",
                  label: "Supplier",
                  numeric: false,
                  width: "22%",
                },
                {
                  id: "storeTitle",
                  label: "Store",
                  numeric: false,
                  width: "18%",
                },
                { id: "amount", label: "Amount", numeric: false, width: "14%" },
                { id: "status", label: "Status", numeric: false, width: "12%" },
              ]}
              data={tableData?.pages[0]?.data?.content || []}
              pageNo={pageNo}
              pageSize={pageSize}
              tableData={tableData?.pages[0]?.data || {}}
              showCheckbox={false}
              showActions={true}
              enableSorting={true}
              showHeader={true}
              showSearch={true}
              showFilter={true}
              showCreateButton={true}
              actions={[]}
              handleChangePage={handleChangePage}
              handleChangeRows={handleChangeRows}
              rowClick={checkPrivileges(
                "ROLE_PURCHASE_CREDITDEBITNOTE_AUTHORIZE",
              )}
              showRowView={showRowView}
              loadingSearch={false}
              headerComponent={
                <StyledInput
                  // fullWidth
                  placeholder={t("Debit Note Number")}
                  handleSearchClick={handleSearchClick}
                  handleChange={handleInputChange}
                  value={search}
                  clearSearch={clearSearch}
                />
              }
            />
          </div>
        )}
      </Box>
    </Box>
  );
}
